module.exports = __webpack_public_path__ + "static/media/disable-checkbox.d6999af1.svg";